const sanitize = (str?: string) => {
  return str ? str.replace(/<\/?([^/>]+)\/?>/gi, "") : str;
};

export default sanitize;
